<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Parametrização do supervisor"
    >
        <Form
            :data="data"
            :index="index"
            ref="Form"
            @save="handleExit"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="handleSave"
                color="primary"
            >
                {{ index == null ? 'Incluir' : 'Alterar' }}
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null,
    }),
    methods: {
        open(index) {

            this.index = index
            this.$refs.RkmModal.show()
        },
        handleExit(data) {

            this.$emit('save', data)
            this.$refs.RkmModal.hide()
        },
        handleSave() {

            this.$refs.Form.save()
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>